module.exports = __webpack_public_path__ + "img/ic_arrow_left.fec41b8d.svg";